export default "__VITE_ASSET__Cph81efR__"